var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-address-1{fill:#669df6;}.cls-address-2{fill:#4285f4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_ExternalIPAddressesColor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-address-1",
    d: "M17.49,12.4v6.7a.4.4,0,0,1-.4.4H4.9a.4.4,0,0,1-.4-.4V6.9a.4.4,0,0,1,.4-.4h6.7a.4.4,0,0,0,.4-.4V4.4a.4.4,0,0,0-.4-.4H2.4a.4.4,0,0,0-.4.4V21.6a.4.4,0,0,0,.4.4H19.6a.4.4,0,0,0,.4-.4V12.4a.4.4,0,0,0-.4-.4H17.89A.4.4,0,0,0,17.49,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-address-2",
    d: "M14,2.4V9.6a.4.4,0,0,0,.4.4h7.2a.4.4,0,0,0,.4-.4V2.4a.4.4,0,0,0-.4-.4H14.4A.4.4,0,0,0,14,2.4Zm5.6,4.1H17.89a.4.4,0,0,1-.4-.4V4.4a.4.4,0,0,1,.4-.4H19.6a.4.4,0,0,1,.4.4V6.1A.4.4,0,0,1,19.6,6.5Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.20dd4a24050d3524881af259741ac52c.svg";
export { ForwardRef as ReactComponent };